// extracted by mini-css-extract-plugin
export default {"detail":"TermsService_detail__DRvJf","dot":"TermsService_dot__cY6Ha"};